import BaseSelectBox from 'components/atoms/base-select-box';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useFilter } from './filter/use-filter';
import s from './styles.module.scss';

export const SelectLanguage: FC = () => {
  const { t } = useTranslation();
  const { languageOptions, updateFilter, filter } = useFilter();

  return (
    <div className={s['form-group']}>
      <label>{t('labels.selectLanguage')}</label>
      <div className={s['form-group']}>
        <BaseSelectBox
          value={filter.language}
          defaultValue={languageOptions[0]}
          onChange={(value: string) => {
            updateFilter({ language: value === 'all' ? undefined : value });
          }}
          options={languageOptions}
        />
      </div>
    </div>
  );
};
